import { UserJobOffer } from 'javascripts/api/generated'
import { UserJobOfferWithInfo } from 'spa/member/types/userJobOfferWithInfo'
import Session from 'javascripts/layouts/v2/Session'

const isFavorite = (jobOfferId: number, session: Session) => {
  if (!session) { return false }

  return session.favorite_job_offer_ids.includes(jobOfferId)
}

const isApplied = (jobOfferId: number, session: Session) => {
  if (!session) { return false }

  return Boolean(session.user?.applied_job_offer_ids.includes(jobOfferId))
}

export const decorate = (jobOffers: UserJobOffer[], session: Session): UserJobOfferWithInfo[] => {
  return jobOffers.map(jobOffer => {
    const job_offer_id = jobOffer.id
    return {
      detail: jobOffer,
      isFavorite: isFavorite(job_offer_id, session),
      isApplied: isApplied(job_offer_id, session)
    }
  })
}